import {Component, Input, OnInit} from '@angular/core';
import {DataStoreService} from "../../shared/services/api/data-store.service";
import {CustomerCategory} from "../../shared/models/customer-category";
import {FormArray, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {NotificationsService} from "angular2-notifications";
import { JsonApiDatastore, JsonApiModel, ModelType } from "angular2-jsonapi";


export interface FormField {
  name: string,
  title: string,
  icon?: string,
  type?: string
  control: FormControl
}

@Component({
  selector: 'app-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.css']
})
export class CategoryComponent<T extends JsonApiModel> implements OnInit {

  private categories: T[];
  form: FormArray = new FormArray([]);

  @Input() type: ModelType<T>;
  @Input() name: string;
  @Input() formFieldsFactory: (T) => FormField[];

  private fields: FormField[] = [];

  constructor(private dataStore: DataStoreService,
              private formBuilder: FormBuilder,
              private notificationService: NotificationsService) {
  }

  ngOnInit() {

    this.fields = this.formFieldsFactory(this.dataStore.createRecord(this.type));

    this.dataStore.findAll(this.type).map(doc => doc.getModels()).subscribe(categories => {
      if (categories.length == 0) {
        this.categories = [this.dataStore.createRecord(this.type)];
      } else {
        this.categories = categories;
      }
      this.createForm()
    });

  }

  createForm() {
    this.form = new FormArray(this.categories.map(category => this.createCategoryForm(category)));
  }

  createCategoryForm(category: T): FormGroup {
    let formGroup = this.formBuilder.group({
      "object": [category],
    });
    let formFields = this.formFieldsFactory(category);
    formFields.forEach(formField => formGroup.addControl(formField.name, formField.control))
    return formGroup;
  }

  addCategory() {
    var category = this.dataStore.createRecord(this.type);
    this.form.push(this.createCategoryForm(category));
  }

  submit() {
    Observable.from(this.form.controls)
      .filter(control => control.dirty && control.valid)
      .map(control => control.value)
      .flatMap((category: any) => {
        let ca = category.object as T;
        delete category.object;
        Object.assign(ca, category);
        return ca.save();
      }).subscribe(null, (error) => this.notificationService.error("Fehler", "Fehler beim Speichern der Kategorien"),
      () => this.notificationService.success("Kategorien gespeichert", this.name + " wurden gepseichert"));
  }

  removeCategory(index: number) {
    let cat = this.form.controls[index].value.object as T;
    this.dataStore.deleteRecord(this.type, cat.id)
      .subscribe(response => {
        this.notificationService.success("Kategorie gelöscht", this.name + " ID " + cat.id + " wurde gelöscht");
        this.form.removeAt(index);
      })
  }

}



// WEBPACK FOOTER //
// /home/markush/Projects/fieldsale-wingman-client/src/app/settings/category/category.component.ts